import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import RenderIf from '../render-if/Renderif';
import { Box } from '@mui/material';
import Tooltip from './Tooltip';

const ITEM_HEIGHT = 40;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};

const HELP_ICON_TOOLTIP = 'Select which defendants each image pertains to';
const labelRowClasses = "flex items-center gap-1.5";
const labelTextClasses = "text-sm whitespace-nowrap";



export default function MultipleSelectCheckmarks({dataArr,handleSelect,initValue=[],imageName,formik,isLiability,index,handleIsLiabilityAddedCheckbox,disabled}) {

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    handleSelect(value)
  };

  return (
    <FormControl sx={{ width:'100%' }}>
        <Box className={labelRowClasses}>
            <Checkbox
              checked={isLiability}
              sx={{padding:0}}
              disabled={disabled}
              onChange={(e) => handleIsLiabilityAddedCheckbox(e, index)}
            />
            <span className={labelTextClasses}>{imageName}</span>
            <RenderIf shouldRender={!formik?.values?.caseInfo?.isSingleLiabilitySectionForAllDefendants}>
              <Tooltip title={HELP_ICON_TOOLTIP} placement="top">
                <i className="fa fa-info-circle cursor-pointer p-1 inline-flex justify-center relative z-[1] text-primary!" tabIndex="0" role="button" />
              </Tooltip>
            </RenderIf>
        </Box>
      <RenderIf shouldRender={!formik?.values?.caseInfo?.isSingleLiabilitySectionForAllDefendants}>
        <Box display="flex" alignItems="center" marginTop={3}>
          {/* Checkbox Section */}
          
          {/* Dropdown Section */}
          <FormControl sx={{flex: 1, minWidth: 150}}>
            <InputLabel
              id="demo-multiple-checkbox-label"
              sx={{
                background: "var(--color-white)",
                fontSize:'13px'
                // paddingRight: "2px"
              }}
            >
              Select Defendants
            </InputLabel>
            <Select
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              multiple
              disabled={disabled}
              value={dataArr.filter((elem) => initValue.includes(elem.id))}
              onChange={handleChange}
              input={<OutlinedInput label="Defendants" />}
              renderValue={(selected) => selected.map((item) => item.name).join(", ")}
              MenuProps={MenuProps}
            >
              {dataArr.map((elem) => (
                <MenuItem key={elem.id} value={elem}>
                  <Checkbox checked={initValue.includes(elem.id)} />
                  <ListItemText primary={elem.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </RenderIf>


    </FormControl>
    
  );
}